import { render } from "./DevBar.vue?vue&type=template&id=119fda01&ts=true"
import script from "./DevBar.vue?vue&type=script&lang=ts"
export * from "./DevBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__